import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const ocScrollTriggerState = atom({
  key: "ocScrollTriggerState",
  default: "hide",
  effects_UNSTABLE: [ocPersistAtom],
});
